import {
  GET_PROJECT_REQUEST,
  GET_PROJECTS_REQUEST,
  CLEAR_PROJECTS_STATE,
  INIT_REDUCER,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  CREATE_PROJECT_REQUEST,
  CLEAR_CREATE_STATE,
  EDIT_PROJECT_REQUEST,
  DELETE_PROJECT_REQUEST,
} from './types';

const getProject = (payload) => ({
  type: GET_PROJECT_REQUEST,
  payload,
});

const getProjects = (payload) => {
  return {
    type: GET_PROJECTS_REQUEST,
    payload,
  };
};

const createProject = (payload) => {
  return {
    type: CREATE_PROJECT_REQUEST,
    payload,
  };
};

const editProject = (payload) => {
  return {
    type: EDIT_PROJECT_REQUEST,
    payload,
  };
};

const deleteProject = (payload) => {
  return {
    type: DELETE_PROJECT_REQUEST,
    payload,
  };
};

const clearProjectsState = () => ({
  type: CLEAR_PROJECTS_STATE,
});

const clearCreateProjectsState = () => ({
  type: CLEAR_CREATE_STATE,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const clearErrorsProfile = () => ({
  type: CLEAR_ERRORS_PROFILE,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

export {
  getProject,
  getProjects,
  createProject,
  deleteProject,
  clearProjectsState,
  initReducer,
  clearErrors,
  clearErrorsProfile,
  createErrors,
  clearCreateProjectsState,
  editProject,
};
